import React, { useEffect, useState } from "react";
import * as Constants from "../../constants/urls";
import axios from "axios";
import Header from "../Header/Header";
import { Drawer } from "@material-ui/core";
import RightMenu from "../RightMenu";
import { useCookies } from "react-cookie";
import Pagination from "react-js-pagination";
import { DatePicker } from "zaman";
import moment from "moment-jalaali";
import Loading from "../Loading/Loading";
import Breadcrumb from "../Breadcrumb/Breadcrumb";
import { useLocation } from "react-router-dom";

function Orders() {
    const [state, setState] = useState({ right: false });
    const [cookies, setCookie, removeCookie] = useCookies();
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);

    const [date1, setDate1] = useState(0);
    const [date2, setDate2] = useState(0);
    const [delivaryDate1, setdelivaryDate1] = useState(0);
    const [delivaryDate2, setdelivaryDate2] = useState(0);
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const username = queryParams.get('username'); 
    
  
    const [filters, setFilters] = useState([
        {
            key: "id",
            value: null
        }, {
            key: "total_items",
            value: null
        },
        {
            key: "user",
            value: null
        },
        {
            key: "order_item_count",
            value: null
        },
        {
            key: "basket_barcode",
            value: null
        },
        {
            key: "deliverMode",
            value: null
        },
        {
            key: "stat",
            value: -1
        },
        {
            key: "userID",
            value: username
        },
        {
            key: "dateRange",
            value: null
        }
        ,
        {
            key: "postTime",
            value: null
        }

    ]);
    const status = [
        {
            id: 1,
            label: "ثبت سفارش",
            color: "#28a745"
        }
        ,
        {
            id: 2,
            label: "آماده سازی",
            color: "#4f6b7e"
        }
        ,
        {
            id: 3,
            label: "پایان آماده سازی",
            color: "#009dff"
        }
        ,
        {
            id: 4,
            label: 'بررسی سفارش',
            color: "#ae26ff"
        }
        ,
        {
            id: 5,
            label: 'بسته بندی',
            color: "#ff5722"
        }
        ,
        {
            id: 6,
            label: 'پرداخت نشده',
            color: "#ff0000"
        }
        ,
        {
            id: 7,
            label: 'کنسل شده',
            color: "#ff0000"
        }
        ,
        {
            id: 8,
            label: 'پرداخت شده',
            color: "#658300"
        }
        ,
        {
            id: 9,
            label: 'ارسال شده',
            color: "#1b876d"
        }
    ]
    const orderStatus = [
        'ثبت سفارش',
        'آماده سازی',
        'پایان آماده سازی',
        'بررسی سفارش',
        'بسته بندی',
        'پرداخت نشده',
        'کنسل شده',
        'پرداخت شده',
        'ارسال شده',
    ]


    const delivery = [
        {
            id: 14,
            label: "پست",
            color: "#e5a30f"
        }
        ,
        {
            id: 16,
            label: "تپسی",
            color: "#ff5722"
        }
        ,
        {
            id: 17,
            label: "الوپیک",
            color: "#00bfff"
        }
        ,
        {
            id: 18,
            label: "پیک فوری",
            color: "#21aa58"
        }
        ,
        {
            id: 19,
            label: "zap",
            color: "#909090"
        }
    ]

    function filterHandle(e) {
        let key = e.target.name;
        let value = e.target.value;
        let oldValue = "";
        const newFilter = filters.map(obj => {
            if (obj.key == key) {
                oldValue = obj.value;
                return { ...obj, value: value };
            }
            return obj;
        });
        if (oldValue != value)
            setFilters(newFilter)
    }

    const deliveryHandleSearch = (searchId) => {
        const found = delivery.find(item => item.id === parseInt(searchId, 10));
        return found;
    };

    const statusHandleSearch = (searchId) => {
        const found = status.find(item => item.id === parseInt(searchId, 10));
        return found;
    };

    const toggleDrawer = (anchor, open) => (event) => {
        if (
            event.type === "keydown" &&
            (event.key === "Tab" || event.key === "Shift")
        ) {
            return;
        }
        setState({ ...state, [anchor]: open });
    };

    useEffect(() => {
        getData();
    }, []);

    useEffect(() => {
        getData(1);
    }, [filters]);

    function getData(page = 1) {
        setLoading(true);
        let filterUrl = "?";
        filters.map((item) => {
            if (item.value != null)
                filterUrl += `filter[${item.key}]=${item.value}&`
        })

        const url = Constants.apiUrl + "/api/orders" + filterUrl;
        axios
            .post(url, {
                page: page
            }, {
                headers: {
                    Authorization: "Bearer " + cookies.user_server_token,
                },
            })
            .then((r) => {
                setData(r.data.data)
                setLoading(false);

                console.log(r)
            })
            .catch((e) => {
                setLoading(false);

            });

    }
  
    const handleDateRangepicker = ({ from, to }) => {
        let startDate = new Date(from);
        let endDate = new Date(to);

        // تبدیل تاریخ‌ها به یونیکس تایم‌استمپ (ثانیه‌ها از Epoch)
        let startTimestamp = Math.floor(startDate.getTime() / 1000);
        let endTimestamp = Math.floor(endDate.getTime() / 1000);

        console.log(startTimestamp);
        
        setDate1(startTimestamp);
        setDate2(endTimestamp);

        const key = 'dateRange';
        const updatedFilters = filters.map(filter => {
            if (filter.key === key) {
                return { ...filter, value: [startTimestamp, endTimestamp] };
            }
            return filter;
        });
    
        // اگر فیلتر تاریخ وجود نداشت، اضافه کنید
        const filterExists = filters.some(filter => filter.key === key);
        if (!filterExists) {
            updatedFilters.push({ key, value: [startTimestamp, endTimestamp] });
        }
    
        // به‌روزرسانی state
        setFilters(updatedFilters);
    };
    const handleDatepicker = ({ from, to }) => {
        let startDate = new Date(from);
        let endDate = new Date(to);

        // تبدیل تاریخ‌ها به یونیکس تایم‌استمپ (ثانیه‌ها از Epoch)
        let startTimestamp = Math.floor(startDate.getTime() / 1000);
        let endTimestamp = Math.floor(endDate.getTime() / 1000);

        console.log(startTimestamp);
        
        setDate1(startTimestamp);
        setDate2(endTimestamp);

        const key = 'postTime';
        const updatedFilters = filters.map(filter => {
            if (filter.key === key) {
                return { ...filter, value: [startTimestamp, endTimestamp] };
            }
            return filter;
        });
    
        // اگر فیلتر تاریخ وجود نداشت، اضافه کنید
        const filterExists = filters.some(filter => filter.key === key);
        if (!filterExists) {
            updatedFilters.push({ key, value: [startTimestamp, endTimestamp] });
        }
    
        // به‌روزرسانی state
        setFilters(updatedFilters);
    };

       const handleDateFilter = ( from, to  ) => { 
        const key = 'postTime';
        const updatedFilters = filters.map(filter => {
            if (filter.key === key) {
                return { ...filter, value: [from, to] };
            }
            return filter;
        });

        const filterExists = filters.some(filter => filter.key === key);
        if (!filterExists) {
            updatedFilters.push({ key, value: [from, to] });
        }
        setFilters(updatedFilters);
    };

    return (<>

        <Breadcrumb title={"سفارشات"} />
        {
            loading && <Loading />
        }


        <div className="container-fluid ">
            <div className="table-responsive mb-5">
                <table className="table table-light table-hover" style={{ fontSize: "12px" }}>
                    <thead className=" ">
                        <tr>
                            <th>شناسه سفارش</th>
                            <th>نام مشتری</th>
                            <th>شماره موبایل</th>
                            <th>شماره سبد</th>
                            <th>روش ارسال</th>

                            <th>تاریخ سفارش</th>
                            <th>تاریخ ارسال</th>
                            <th>مرحله</th>

                            <th>عملیات</th>
                        </tr>
                        <tr className={" "}>
                            <th>
                                <input name={"id"} onBlur={filterHandle} type={"text"}
                                    className={"form-control text-center"} />
                            </th>
                            <th>
                                <input name={"user"} onBlur={filterHandle} type={"text"}
                                    className={"form-control text-center"} />
                            </th>
                            <th>
                                <input name={"userID"} onBlur={filterHandle} type={"text"}
                                    className={"form-control text-center"} />
                            </th>
                            <th>
                                <input name={"basket_barcode"} onBlur={filterHandle} type={"text"}
                                    className={"form-control text-center"} />
                            </th>
                            <th>
                                <select name={"deliverMode"} onChange={filterHandle} className={"form-control text-center"}>
                                    <option value={""}>
                                        همه
                                    </option>
                                    {
                                        delivery.map((item) => (<option value={item.id}>
                                            {
                                                item.label
                                            }
                                        </option>))
                                    }
                                </select>
                            </th>

                            <th>
                                <DatePicker
                                    inputClass="bannerModalInputs text-sm p-0 m-0"
                                    direction="ltr"
                                    round="x2"
                                    name={"date"}
                                    accentColor="#6374ae"
                                    range={true}
                                    onChange={handleDateRangepicker}
                                />
                            </th>
                            <th>
                                <DatePicker
                                    name={"postTime"}
                                    inputClass="bannerModalInputs"
                                    direction="ltr"
                                    round="x2"
                                    range={true}

                                    accentColor="#6374ae"
                                    onChange={handleDatepicker}
                                />
                            </th>
                            <th>
                                <select name={"stat"} onChange={filterHandle} className={"form-control text-center"}>
                                    <option value={""}>
                                        همه
                                    </option>
                                    <option value={-1} selected={true}>
                                        عدم نمایش کنسل شده ها
                                    </option>
                                    {orderStatus.map((item, key) => (
                                        <option value={key + 1}>
                                            {item}
                                        </option>
                                    ))}

                                </select>
                            </th>
                            <th className={" "}>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            data.data && data.data.map((item) => (<>
                                <tr>
                                    <th className={"bg-danger text-white text-center"}>{item.id}</th>
                                    <th>
                                        {item.order_info.fname + " " + item.order_info.lname}
                                    </th>
                                    <th>
                                        {item.userID}
                                    </th>
                                    <th>
                                        {item.basket_barcode}
                                    </th>

                                    <th>
                                        <div className={"badge badge-light badge-pill text-white"}
                                            style={{ backgroundColor: deliveryHandleSearch(item.deliverMode) ? deliveryHandleSearch(item.deliverMode).color : "#000" }}>
                                            <small>
                                                {
                                                    deliveryHandleSearch(item.deliverMode) ? deliveryHandleSearch(item.deliverMode).label : "غیره"
                                                }
                                            </small>
                                        </div>

                                    </th>
                                    <th style={{ direction: "ltr" }}>
                                        {
                                            moment(item.date * 1000).format('jYYYY/jM/jD H:m:s')
                                        }
                                    </th>
                                    <th style={{ direction: "ltr",cursor:"pointer" }} onClick={()=>{handleDateFilter(item.order_info.post_time-1,item.order_info.post_time+1)}}>
                                        {
                                            item.order_info.post_time != "0" ? moment(item.order_info.post_time * 1000).format('jYYYY/jM/jD H:m:s') : "---"
                                        }
                                    </th>
                                    <th>
                                        <div className={"badge badge-light badge-pill text-white  "}
                                            style={{ backgroundColor: statusHandleSearch(item.stat) ? statusHandleSearch(item.stat).color : "#000" }}>
                                            <small>
                                                {
                                                    statusHandleSearch(item.stat) ? statusHandleSearch(item.stat).label : ""
                                                }
                                            </small>
                                        </div>

                                    </th>
                                    <th>
                                        <div className={"btn-group"}>


                                            <a className={"btn btn-success ml-2"} target={"_blank"}
                                                href={Constants.oldAdminUrl + "/orders/factor/" + item.id}>
                                                فاکتور
                                            </a>
                                            {item.stat == 3 ? <a className={"btn btn-danger"} target={"_blank"}
                                                href={Constants.oldAdminUrl + "/orders/factor_checking_barcode/" + item.id}>
                                                چک کردن
                                            </a>
                                                :
                                                <a className={"btn btn-primary"} target={"_blank"}
                                                    href={Constants.oldAdminUrl + "/orders/factor_checking?order_id=" + item.id}>
                                                    پیک کردن
                                                </a>
                                            }
                                        </div>
                                    </th>
                                </tr>
                            </>))
                        }

                    </tbody>
                </table>
            </div>

            <div className="pager Page navigation example">
                <Pagination
                    totalItemsCount={data.total}
                    activePage={data.current_page}
                    itemsCountPerPage={data.per_page}
                    onChange={(number) => {
                        getData(number);
                    }}
                    itemClass="page-item"
                    linkClass="page-link"
                    firstPageText="اولین صفحه"
                    lastPageText="آخرین صفحه"
                    nextPageText="بعدی"
                    prevPageText="قبلی"
                    activeClass="pageactive"
                />
            </div>
        </div>

    </>);
}

export default Orders;
